/**
 * Shared helpers for client-side polling intervals.
 *
 * Every browser tab that opens around the same time (a deploy, a shared
 * onboarding link, a demo) ends up polling in near-lockstep on a flat
 * interval, turning steady traffic into periodic spikes against the
 * container backend. Jittering the delay spreads that out.
 */

/**
 * Returns `ms` randomized by +/- `fraction` (default 20%). Use as the
 * delay passed to `setInterval`/`setTimeout` for any polling loop.
 */
export function withJitter(ms: number, fraction = 0.2): number {
  const delta = ms * fraction;
  return Math.round(ms - delta + Math.random() * delta * 2);
}

/**
 * True when the current tab is backgrounded (not visible). Ambient pollers —
 * ones that run for the lifetime of a mounted component rather than until a
 * specific async job resolves — should skip their tick when this is true,
 * so backgrounded tabs stop generating load against the backend.
 */
export function isTabHidden(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}
